import TextField from '@/components/inputs/TextField';

export type NotesFieldProps = {
  className?: string;
  value: string;
  onChange: (update: string) => void;
};

export default function NotesField({
  className,
  value,
  onChange,
}: NotesFieldProps) {
  return (
    <TextField
      multiline
      className={className}
      minRows={5}
      maxRows={8}
      label="Notes (optional)"
      value={value}
      onChange={onChange}
    />
  );
}
